import * as THREE from "../../libs/three.js/build/three.module.js";
import { GeoJSONExporter } from "../exporter/GeoJSONExporter.js"
import { DXFExporter } from "../exporter/DXFExporter.js"
import { Volume, SphereVolume } from "../utils/Volume.js"
import { PolygonClipVolume } from "../utils/PolygonClipVolume.js"
import { PropertiesPanel } from "./PropertyPanels/PropertiesPanel.js"
import { PointCloudTree } from "../PointCloudTree.js"
import { Profile } from "../utils/Profile.js"
import { Measure } from "../utils/Measure.js"
import { Annotation } from "../Annotation.js"
import { CameraMode, ClipTask, ClipMethod } from "../defines.js"
import { ScreenBoxSelectTool } from "../utils/ScreenBoxSelectTool.js"
import { Utils } from "../utils.js"
import { CameraAnimation } from "../modules/CameraAnimation/CameraAnimation.js"
import { HierarchicalSlider } from "./HierarchicalSlider.js"
import { OrientedImage } from "../modules/OrientedImages/OrientedImages.js";
import { Images360 } from "../modules/Images360/Images360.js";
import * as PointCloudApi from "../../page/api/pointcloud.js";
import JSON5 from "../../libs/json5-2.1.3/json5.mjs";
import { POINT_CLOUD_API } from '../../page/api/config.js';

export class Sidebar {

	constructor(viewer) {
		this.viewer = viewer;

		this.measuringTool = viewer.measuringTool;
		this.profileTool = viewer.profileTool;
		this.volumeTool = viewer.volumeTool;

		this.dom = $("#sidebar_root");

		//正在处理的文件的md5
		this.fileMd5s = [];
		// 正在导出矢量的文件的md5
		this.exportVectorMd5s = [];

	}

	createToolIcon(icon, title, callback) {
		let element = $(`
			<img src="${icon}"
				style="width: 32px; height: 32px"
				class="button-icon"
				data-i18n="${title}" />
		`);

		element.click(callback);

		return element;
	}

	init() {
		this.initAccordion();
		this.initAppearance();
		this.initToolbar();
		this.initScene();
		this.initNavigation();
		// this.initFilters();
		this.initClippingTool();
		this.initSettings();
		this.initFileUpload();
		this.loadPointCloudList();
		this.initPointCloudHandle();
		this.initPointCloudVector()
		$('#potree_version_number').html(Potree.version.major + "." + Potree.version.minor + Potree.version.suffix);
	}



	initToolbar() {

		// ANGLE
		let elToolbar = $('#tools');
		elToolbar.append(this.createToolIcon(
			Potree.resourcePath + '/icons/angle.png',
			'[title]tt.angle_measurement',
			() => {
				$('#menu_measurements').next().slideDown();
				let measurement = this.measuringTool.startInsertion({
					showDistances: false,
					showAngles: true,
					showArea: false,
					closed: true,
					maxMarkers: 3,
					name: 'Angle'
				});

				let measurementsRoot = $("#jstree_scene").jstree().get_json("measurements");
				let jsonNode = measurementsRoot.children.find(child => child.data.uuid === measurement.uuid);
				$.jstree.reference(jsonNode.id).deselect_all();
				$.jstree.reference(jsonNode.id).select_node(jsonNode.id);
			}
		));

		// POINT
		elToolbar.append(this.createToolIcon(
			Potree.resourcePath + '/icons/point.svg',
			'[title]tt.point_measurement',
			() => {
				$('#menu_measurements').next().slideDown();
				let measurement = this.measuringTool.startInsertion({
					showDistances: false,
					showAngles: false,
					showCoordinates: true,
					showArea: false,
					closed: true,
					maxMarkers: 1,
					name: 'Point'
				});

				let measurementsRoot = $("#jstree_scene").jstree().get_json("measurements");
				let jsonNode = measurementsRoot.children.find(child => child.data.uuid === measurement.uuid);
				$.jstree.reference(jsonNode.id).deselect_all();
				$.jstree.reference(jsonNode.id).select_node(jsonNode.id);
			}
		));

		// DISTANCE
		elToolbar.append(this.createToolIcon(
			Potree.resourcePath + '/icons/distance.svg',
			'[title]tt.distance_measurement',
			() => {
				$('#menu_measurements').next().slideDown();
				let measurement = this.measuringTool.startInsertion({
					showDistances: true,
					showArea: false,
					closed: false,
					name: 'Distance'
				});

				let measurementsRoot = $("#jstree_scene").jstree().get_json("measurements");
				let jsonNode = measurementsRoot.children.find(child => child.data.uuid === measurement.uuid);
				$.jstree.reference(jsonNode.id).deselect_all();
				$.jstree.reference(jsonNode.id).select_node(jsonNode.id);
			}
		));

		// HEIGHT
		elToolbar.append(this.createToolIcon(
			Potree.resourcePath + '/icons/height.svg',
			'[title]tt.height_measurement',
			() => {
				$('#menu_measurements').next().slideDown();
				let measurement = this.measuringTool.startInsertion({
					showDistances: false,
					showHeight: true,
					showArea: false,
					closed: false,
					maxMarkers: 2,
					name: 'Height'
				});

				let measurementsRoot = $("#jstree_scene").jstree().get_json("measurements");
				let jsonNode = measurementsRoot.children.find(child => child.data.uuid === measurement.uuid);
				$.jstree.reference(jsonNode.id).deselect_all();
				$.jstree.reference(jsonNode.id).select_node(jsonNode.id);
			}
		));

		// CIRCLE
		elToolbar.append(this.createToolIcon(
			Potree.resourcePath + '/icons/circle.svg',
			'[title]tt.circle_measurement',
			() => {
				$('#menu_measurements').next().slideDown();
				let measurement = this.measuringTool.startInsertion({
					showDistances: false,
					showHeight: false,
					showArea: false,
					showCircle: true,
					showEdges: false,
					closed: false,
					maxMarkers: 3,
					name: 'Circle'
				});

				let measurementsRoot = $("#jstree_scene").jstree().get_json("measurements");
				let jsonNode = measurementsRoot.children.find(child => child.data.uuid === measurement.uuid);
				$.jstree.reference(jsonNode.id).deselect_all();
				$.jstree.reference(jsonNode.id).select_node(jsonNode.id);
			}
		));

		// AZIMUTH
		elToolbar.append(this.createToolIcon(
			Potree.resourcePath + '/icons/azimuth.svg',
			'Azimuth',
			() => {
				$('#menu_measurements').next().slideDown();
				let measurement = this.measuringTool.startInsertion({
					showDistances: false,
					showHeight: false,
					showArea: false,
					showCircle: false,
					showEdges: false,
					showAzimuth: true,
					closed: false,
					maxMarkers: 2,
					name: 'Azimuth'
				});

				let measurementsRoot = $("#jstree_scene").jstree().get_json("measurements");
				let jsonNode = measurementsRoot.children.find(child => child.data.uuid === measurement.uuid);
				$.jstree.reference(jsonNode.id).deselect_all();
				$.jstree.reference(jsonNode.id).select_node(jsonNode.id);
			}
		));

		// AREA
		elToolbar.append(this.createToolIcon(
			Potree.resourcePath + '/icons/area.svg',
			'[title]tt.area_measurement',
			() => {
				$('#menu_measurements').next().slideDown();
				let measurement = this.measuringTool.startInsertion({
					showDistances: true,
					showArea: true,
					closed: true,
					name: 'Area'
				});

				let measurementsRoot = $("#jstree_scene").jstree().get_json("measurements");
				let jsonNode = measurementsRoot.children.find(child => child.data.uuid === measurement.uuid);
				$.jstree.reference(jsonNode.id).deselect_all();
				$.jstree.reference(jsonNode.id).select_node(jsonNode.id);
			}
		));

		// VOLUME
		elToolbar.append(this.createToolIcon(
			Potree.resourcePath + '/icons/volume.svg',
			'[title]tt.volume_measurement',
			() => {
				let volume = this.volumeTool.startInsertion();

				let measurementsRoot = $("#jstree_scene").jstree().get_json("measurements");
				let jsonNode = measurementsRoot.children.find(child => child.data.uuid === volume.uuid);
				$.jstree.reference(jsonNode.id).deselect_all();
				$.jstree.reference(jsonNode.id).select_node(jsonNode.id);
			}
		));

		// SPHERE VOLUME
		elToolbar.append(this.createToolIcon(
			Potree.resourcePath + '/icons/sphere_distances.svg',
			'[title]tt.volume_measurement',
			() => {
				let volume = this.volumeTool.startInsertion({ type: SphereVolume });

				let measurementsRoot = $("#jstree_scene").jstree().get_json("measurements");
				let jsonNode = measurementsRoot.children.find(child => child.data.uuid === volume.uuid);
				$.jstree.reference(jsonNode.id).deselect_all();
				$.jstree.reference(jsonNode.id).select_node(jsonNode.id);
			}
		));

		// PROFILE
		elToolbar.append(this.createToolIcon(
			Potree.resourcePath + '/icons/profile.svg',
			'[title]tt.height_profile',
			() => {
				$('#menu_measurements').next().slideDown();;
				let profile = this.profileTool.startInsertion();

				let measurementsRoot = $("#jstree_scene").jstree().get_json("measurements");
				let jsonNode = measurementsRoot.children.find(child => child.data.uuid === profile.uuid);
				$.jstree.reference(jsonNode.id).deselect_all();
				$.jstree.reference(jsonNode.id).select_node(jsonNode.id);
			}
		));

		// ANNOTATION
		elToolbar.append(this.createToolIcon(
			Potree.resourcePath + '/icons/annotation.svg',
			'[title]tt.annotation',
			() => {
				$('#menu_measurements').next().slideDown();;
				let annotation = this.viewer.annotationTool.startInsertion();

				let annotationsRoot = $("#jstree_scene").jstree().get_json("annotations");
				let jsonNode = annotationsRoot.children.find(child => child.data.uuid === annotation.uuid);
				$.jstree.reference(jsonNode.id).deselect_all();
				$.jstree.reference(jsonNode.id).select_node(jsonNode.id);
			}
		));

		// REMOVE ALL
		elToolbar.append(this.createToolIcon(
			Potree.resourcePath + '/icons/reset_tools.svg',
			'[title]tt.remove_all_measurement',
			() => {
				this.viewer.scene.removeAllMeasurements();
			}
		));


		{ // SHOW / HIDE Measurements
			let elShow = $("#measurement_options_show");
			elShow.selectgroup({ title: "Show/Hide labels" });

			elShow.find("input").click((e) => {
				const show = e.target.value === "SHOW";
				this.measuringTool.showLabels = show;
			});

			let currentShow = this.measuringTool.showLabels ? "SHOW" : "HIDE";
			elShow.find(`input[value=${currentShow}]`).trigger("click");
		}
	}

	initScene() {

		let elScene = $("#menu_scene");
		let elObjects = elScene.next().find("#scene_objects");
		let elProperties = elScene.next().find("#scene_object_properties");


		{
			let elExport = elScene.next().find("#scene_export");

			let geoJSONIcon = `${Potree.resourcePath}/icons/file_geojson.svg`;
			let dxfIcon = `${Potree.resourcePath}/icons/file_dxf.svg`;
			let potreeIcon = `${Potree.resourcePath}/icons/file_potree.svg`;

			elExport.append(`
				Export: <br>
				<a href="#" download="measure.json"><img name="geojson_export_button" src="${geoJSONIcon}" class="button-icon" style="height: 24px" /></a>
				<a href="#" download="measure.dxf"><img name="dxf_export_button" src="${dxfIcon}" class="button-icon" style="height: 24px" /></a>
				<a href="#" download="potree.json5"><img name="potree_export_button" src="${potreeIcon}" class="button-icon" style="height: 24px" /></a>
			`);

			let elDownloadJSON = elExport.find("img[name=geojson_export_button]").parent();
			elDownloadJSON.click((event) => {
				let scene = this.viewer.scene;
				let measurements = [...scene.measurements, ...scene.profiles, ...scene.volumes];

				if (measurements.length > 0) {
					let geoJson = GeoJSONExporter.toString(measurements);

					let url = window.URL.createObjectURL(new Blob([geoJson], { type: 'data:application/octet-stream' }));
					elDownloadJSON.attr('href', url);
				} else {
					this.viewer.postError("没有测量数据导出");
					event.preventDefault();
				}
			});

			let elDownloadDXF = elExport.find("img[name=dxf_export_button]").parent();
			elDownloadDXF.click((event) => {
				let scene = this.viewer.scene;
				let measurements = [...scene.measurements, ...scene.profiles, ...scene.volumes];

				if (measurements.length > 0) {
					let dxf = DXFExporter.toString(measurements);

					let url = window.URL.createObjectURL(new Blob([dxf], { type: 'data:application/octet-stream' }));
					elDownloadDXF.attr('href', url);
				} else {
					this.viewer.postError("没有测量数据导出");
					event.preventDefault();
				}
			});

			let elDownloadPotree = elExport.find("img[name=potree_export_button]").parent();
			elDownloadPotree.click((event) => {

				let data = Potree.saveProject(this.viewer);
				let dataString = JSON5.stringify(data, null, "\t")

				let url = window.URL.createObjectURL(new Blob([dataString], { type: 'data:application/octet-stream' }));
				elDownloadPotree.attr('href', url);
			});
		}

		let propertiesPanel = new PropertiesPanel(elProperties, this.viewer);
		propertiesPanel.setScene(this.viewer.scene);

		localStorage.removeItem('jstree');

		let tree = $(`<div id="jstree_scene"></div>`);
		elObjects.append(tree);

		tree.jstree({
			'plugins': ["checkbox", "state"],
			'core': {
				"scroll": false, // 禁用自动滚动
				"dblclick_toggle": false,
				"state": {
					"checked": true
				},
				'check_callback': true,
				"expand_selected_onload": true
			},
			"checkbox": {
				"keep_selected_style": true,
				"three_state": false,
				"whole_node": false,
				"tie_selection": false,
			},
		});

		let createNode = (parent, text, icon, object) => {
			let nodeID = tree.jstree('create_node', parent, {
				"text": text,
				"icon": icon,
				"data": object
			},
				"last", false, false);

			if (object.visible) {
				tree.jstree('check_node', nodeID);
			} else {
				tree.jstree('uncheck_node', nodeID);
			}

			return nodeID;
		}

		let pcID = tree.jstree('create_node', "#", { "text": "<b>Point Clouds</b>", "id": "pointclouds" }, "last", false, false);
		let measurementID = tree.jstree('create_node', "#", { "text": "<b>Measurements</b>", "id": "measurements" }, "last", false, false);
		let annotationsID = tree.jstree('create_node', "#", { "text": "<b>Annotations</b>", "id": "annotations" }, "last", false, false);
		let otherID = tree.jstree('create_node', "#", { "text": "<b>Other</b>", "id": "other" }, "last", false, false);
		let vectorsID = tree.jstree('create_node', "#", { "text": "<b>Vectors</b>", "id": "vectors" }, "last", false, false);
		let imagesID = tree.jstree('create_node', "#", { "text": "<b> Images</b>", "id": "images" }, "last", false, false);

		tree.jstree("check_node", pcID);
		tree.jstree("check_node", measurementID);
		tree.jstree("check_node", annotationsID);
		tree.jstree("check_node", otherID);
		tree.jstree("check_node", vectorsID);
		tree.jstree("check_node", imagesID);

		tree.on('create_node.jstree', (e, data) => {
			tree.jstree("open_all");
		});

		tree.on("select_node.jstree", (e, data) => {
			let object = data.node.data;
			propertiesPanel.set(object);

			this.viewer.inputHandler.deselectAll();

			if (object instanceof Volume) {
				this.viewer.inputHandler.toggleSelection(object);
			}

			$(this.viewer.renderer.domElement).focus();
		});

		tree.on("deselect_node.jstree", (e, data) => {
			propertiesPanel.set(null);
		});

		tree.on("delete_node.jstree", (e, data) => {
			propertiesPanel.set(null);
		});

		// 双击事件
		tree.on('dblclick', '.jstree-anchor', (e) => {

			let instance = $.jstree.reference(e.target);
			let node = instance.get_node(e.target);
			let object = node.data;

			// ignore double click on checkbox
			if (e.target.classList.contains("jstree-checkbox")) {
				return;
			}

			if (object instanceof PointCloudTree) {
				let box = this.viewer.getBoundingBox([object]);
				let node = new THREE.Object3D();
				node.boundingBox = box;
				this.viewer.zoomTo(node, 1, 500);
			} else if (object instanceof Measure) {
				let points = object.points.map(p => p.position);
				let box = new THREE.Box3().setFromPoints(points);
				if (box.getSize(new THREE.Vector3()).length() > 0) {
					let node = new THREE.Object3D();
					node.boundingBox = box;
					this.viewer.zoomTo(node, 2, 500);
				}
			} else if (object instanceof Profile) {
				let points = object.points;
				let box = new THREE.Box3().setFromPoints(points);
				if (box.getSize(new THREE.Vector3()).length() > 0) {
					let node = new THREE.Object3D();
					node.boundingBox = box;
					this.viewer.zoomTo(node, 1, 500);
				}
			} else if (object instanceof Volume) {

				let box = object.boundingBox.clone().applyMatrix4(object.matrixWorld);

				if (box.getSize(new THREE.Vector3()).length() > 0) {
					let node = new THREE.Object3D();
					node.boundingBox = box;
					this.viewer.zoomTo(node, 1, 500);
				}
			} else if (object instanceof Annotation) {
				object.moveHere(this.viewer.scene.getActiveCamera());
			} else if (object instanceof PolygonClipVolume) {
				let dir = object.camera.getWorldDirection(new THREE.Vector3());
				let target;

				if (object.camera instanceof THREE.OrthographicCamera) {
					dir.multiplyScalar(object.camera.right)
					target = new THREE.Vector3().addVectors(object.camera.position, dir);
					this.viewer.setCameraMode(CameraMode.ORTHOGRAPHIC);
				} else if (object.camera instanceof THREE.PerspectiveCamera) {
					dir.multiplyScalar(this.viewer.scene.view.radius);
					target = new THREE.Vector3().addVectors(object.camera.position, dir);
					this.viewer.setCameraMode(CameraMode.PERSPECTIVE);
				}

				this.viewer.scene.view.position.copy(object.camera.position);
				this.viewer.scene.view.lookAt(target);
			} else if (object.type === "SpotLight") {
				let distance = (object.distance > 0) ? object.distance / 4 : 5 * 1000;
				let position = object.position;
				let target = new THREE.Vector3().addVectors(
					position,
					object.getWorldDirection(new THREE.Vector3()).multiplyScalar(distance));

				this.viewer.scene.view.position.copy(object.position);
				this.viewer.scene.view.lookAt(target);
			} else if (object instanceof THREE.Object3D) {
				let box = new THREE.Box3().setFromObject(object);

				if (box.getSize(new THREE.Vector3()).length() > 0) {
					let node = new THREE.Object3D();
					node.boundingBox = box;
					this.viewer.zoomTo(node, 1, 500);
				}
			} else if (object instanceof OrientedImage) {
				// TODO zoom to images

				// let box = new THREE.Box3().setFromObject(object);

				// if(box.getSize(new THREE.Vector3()).length() > 0){
				// 	let node = new THREE.Object3D();
				// 	node.boundingBox = box;
				// 	this.viewer.zoomTo(node, 1, 500);
				// }
			} else if (object instanceof Images360) {
				// TODO
			} else if (object instanceof Geopackage) {
				// TODO
			}
		});

		tree.on("uncheck_node.jstree", (e, data) => {
			let object = data.node.data;

			if (object) {
				object.visible = false;
			}
		});

		tree.on("check_node.jstree", (e, data) => {
			let object = data.node.data;
			if (object) {
				object.visible = true;
			}
		});


		let onPointCloudAdded = (e) => {
			let pointcloud = e.pointcloud;
			let cloudIcon = `${Potree.resourcePath}/icons/cloud.svg`;
			let node = createNode(pcID, pointcloud.name, cloudIcon, pointcloud);
			// 存储点云（pointcloud）的节点ID
			// pointcloud.nodeId = node;

			// 监听点云（pointcloud）的可见性变化
			pointcloud.addEventListener("visibility_changed", () => {
				if (pointcloud.visible) {
					tree.jstree('check_node', node);
				} else {
					tree.jstree('uncheck_node', node);
				}
			});
		};

		let onPointCloudRemoved = (e) => {
			// 获取点云（pointcloud）的节点ID，并从树中删除节点
			// let pointcloud = e.pointcloud;
			// let nodeId = pointcloud.nodeId;
			// tree.jstree('delete_node', nodeId);

			let pointcloudsRoot = $("#jstree_scene").jstree().get_json("pointclouds");
			let jsonNode = pointcloudsRoot.children.find(child => child.data.uuid === e.pointcloud.uuid);
			tree.jstree("delete_node", jsonNode.id);
		};

		let onMeasurementAdded = (e) => {
			let measurement = e.measurement;
			let icon = Utils.getMeasurementIcon(measurement);
			createNode(measurementID, measurement.name, icon, measurement);
		};

		let onVolumeAdded = (e) => {
			let volume = e.volume;
			let icon = Utils.getMeasurementIcon(volume);
			let node = createNode(measurementID, volume.name, icon, volume);

			volume.addEventListener("visibility_changed", () => {
				if (volume.visible) {
					tree.jstree('check_node', node);
				} else {
					tree.jstree('uncheck_node', node);
				}
			});
		};

		let onProfileAdded = (e) => {
			let profile = e.profile;
			let icon = Utils.getMeasurementIcon(profile);
			createNode(measurementID, profile.name, icon, profile);
		};

		let onAnnotationAdded = (e) => {
			let annotation = e.annotation;

			let annotationIcon = `${Potree.resourcePath}/icons/annotation.svg`;
			let parentID = this.annotationMapping.get(annotation.parent);
			let annotationID = createNode(parentID, annotation.title, annotationIcon, annotation);
			this.annotationMapping.set(annotation, annotationID);

			annotation.addEventListener("annotation_changed", (e) => {
				let annotationsRoot = $("#jstree_scene").jstree().get_json("annotations");
				let jsonNode = annotationsRoot.children.find(child => child.data.uuid === annotation.uuid);

				$.jstree.reference(jsonNode.id).rename_node(jsonNode.id, annotation.title);
			});
		};

		let onCameraAnimationAdded = (e) => {
			const animation = e.animation;

			const animationIcon = `${Potree.resourcePath}/icons/camera_animation.svg`;
			createNode(otherID, "animation", animationIcon, animation);
		};

		let onOrientedImagesAdded = (e) => {
			const images = e.images;

			const imagesIcon = `${Potree.resourcePath}/icons/picture.svg`;
			const node = createNode(imagesID, "images", imagesIcon, images);

			images.addEventListener("visibility_changed", () => {
				if (images.visible) {
					tree.jstree('check_node', node);
				} else {
					tree.jstree('uncheck_node', node);
				}
			});
		};

		let onImages360Added = (e) => {
			const images = e.images;

			const imagesIcon = `${Potree.resourcePath}/icons/picture.svg`;
			const node = createNode(imagesID, "360° images", imagesIcon, images);

			images.addEventListener("visibility_changed", () => {
				if (images.visible) {
					tree.jstree('check_node', node);
				} else {
					tree.jstree('uncheck_node', node);
				}
			});
		};

		const onGeopackageAdded = (e) => {
			const geopackage = e.geopackage;

			const geopackageIcon = `${Potree.resourcePath}/icons/triangle.svg`;
			const tree = $(`#jstree_scene`);
			const parentNode = "vectors";

			for (const layer of geopackage.node.children) {
				const name = layer.name;

				let shpPointsID = tree.jstree('create_node', parentNode, {
					"text": name,
					"icon": geopackageIcon,
					"object": layer,
					"data": layer,
				},
					"last", false, false);
				tree.jstree(layer.visible ? "check_node" : "uncheck_node", shpPointsID);
			}

		};

		this.viewer.scene.addEventListener("pointcloud_added", onPointCloudAdded);
		// 监听点云移除事件
		this.viewer.scene.addEventListener("pointcloud_removed", onPointCloudRemoved);
		this.viewer.scene.addEventListener("measurement_added", onMeasurementAdded);
		this.viewer.scene.addEventListener("profile_added", onProfileAdded);
		this.viewer.scene.addEventListener("volume_added", onVolumeAdded);
		this.viewer.scene.addEventListener("camera_animation_added", onCameraAnimationAdded);
		this.viewer.scene.addEventListener("oriented_images_added", onOrientedImagesAdded);
		this.viewer.scene.addEventListener("360_images_added", onImages360Added);
		this.viewer.scene.addEventListener("geopackage_added", onGeopackageAdded);
		this.viewer.scene.addEventListener("polygon_clip_volume_added", onVolumeAdded);
		this.viewer.scene.annotations.addEventListener("annotation_added", onAnnotationAdded);

		let onMeasurementRemoved = (e) => {
			let measurementsRoot = $("#jstree_scene").jstree().get_json("measurements");
			let jsonNode = measurementsRoot.children.find(child => child.data.uuid === e.measurement.uuid);

			tree.jstree("delete_node", jsonNode.id);
		};

		let onVolumeRemoved = (e) => {
			let measurementsRoot = $("#jstree_scene").jstree().get_json("measurements");
			let jsonNode = measurementsRoot.children.find(child => child.data.uuid === e.volume.uuid);

			tree.jstree("delete_node", jsonNode.id);
		};

		let onPolygonClipVolumeRemoved = (e) => {
			let measurementsRoot = $("#jstree_scene").jstree().get_json("measurements");
			let jsonNode = measurementsRoot.children.find(child => child.data.uuid === e.volume.uuid);

			tree.jstree("delete_node", jsonNode.id);
		};

		let onProfileRemoved = (e) => {
			let measurementsRoot = $("#jstree_scene").jstree().get_json("measurements");
			let jsonNode = measurementsRoot.children.find(child => child.data.uuid === e.profile.uuid);

			tree.jstree("delete_node", jsonNode.id);
		};

		this.viewer.scene.addEventListener("measurement_removed", onMeasurementRemoved);
		this.viewer.scene.addEventListener("volume_removed", onVolumeRemoved);
		this.viewer.scene.addEventListener("polygon_clip_volume_removed", onPolygonClipVolumeRemoved);
		this.viewer.scene.addEventListener("profile_removed", onProfileRemoved);

		{
			let annotationIcon = `${Potree.resourcePath}/icons/annotation.svg`;
			this.annotationMapping = new Map();
			this.annotationMapping.set(this.viewer.scene.annotations, annotationsID);
			this.viewer.scene.annotations.traverseDescendants(annotation => {
				let parentID = this.annotationMapping.get(annotation.parent);
				let annotationID = createNode(parentID, annotation.title, annotationIcon, annotation);
				this.annotationMapping.set(annotation, annotationID);
			});
		}

		const scene = this.viewer.scene;
		for (let pointcloud of scene.pointclouds) {
			onPointCloudAdded({ pointcloud: pointcloud });
		}

		for (let measurement of scene.measurements) {
			onMeasurementAdded({ measurement: measurement });
		}

		for (let volume of [...scene.volumes, ...scene.polygonClipVolumes]) {
			onVolumeAdded({ volume: volume });
		}

		for (let animation of scene.cameraAnimations) {
			onCameraAnimationAdded({ animation: animation });
		}

		for (let images of scene.orientedImages) {
			onOrientedImagesAdded({ images: images });
		}

		for (let images of scene.images360) {
			onImages360Added({ images: images });
		}

		for (const geopackage of scene.geopackages) {
			onGeopackageAdded({ geopackage: geopackage });
		}

		for (let profile of scene.profiles) {
			onProfileAdded({ profile: profile });
		}

		{
			createNode(otherID, "Camera", null, new THREE.Camera());
		}

		this.viewer.addEventListener("scene_changed", (e) => {
			propertiesPanel.setScene(e.scene);

			e.oldScene.removeEventListener("pointcloud_added", onPointCloudAdded);
			e.oldScene.removeEventListener("measurement_added", onMeasurementAdded);
			e.oldScene.removeEventListener("profile_added", onProfileAdded);
			e.oldScene.removeEventListener("volume_added", onVolumeAdded);
			e.oldScene.removeEventListener("polygon_clip_volume_added", onVolumeAdded);
			e.oldScene.removeEventListener("measurement_removed", onMeasurementRemoved);

			e.scene.addEventListener("pointcloud_added", onPointCloudAdded);
			e.scene.addEventListener("measurement_added", onMeasurementAdded);
			e.scene.addEventListener("profile_added", onProfileAdded);
			e.scene.addEventListener("volume_added", onVolumeAdded);
			e.scene.addEventListener("polygon_clip_volume_added", onVolumeAdded);
			e.scene.addEventListener("measurement_removed", onMeasurementRemoved);
		});

	}

	initClippingTool() {


		this.viewer.addEventListener("cliptask_changed", (event) => {
			console.log("TODO");
		});

		this.viewer.addEventListener("clipmethod_changed", (event) => {
			console.log("TODO");
		});

		{
			let elClipTask = $("#cliptask_options");
			elClipTask.selectgroup({ title: "Clip Task" });

			elClipTask.find("input").click((e) => {
				this.viewer.setClipTask(ClipTask[e.target.value]);
			});

			let currentClipTask = Object.keys(ClipTask)
				.filter(key => ClipTask[key] === this.viewer.clipTask);
			elClipTask.find(`input[value=${currentClipTask}]`).trigger("click");
		}

		{
			let elClipMethod = $("#clipmethod_options");
			elClipMethod.selectgroup({ title: "Clip Method" });

			elClipMethod.find("input").click((e) => {
				this.viewer.setClipMethod(ClipMethod[e.target.value]);
			});

			let currentClipMethod = Object.keys(ClipMethod)
				.filter(key => ClipMethod[key] === this.viewer.clipMethod);
			elClipMethod.find(`input[value=${currentClipMethod}]`).trigger("click");
		}

		let clippingToolBar = $("#clipping_tools");

		// CLIP VOLUME
		clippingToolBar.append(this.createToolIcon(
			Potree.resourcePath + '/icons/clip_volume.svg',
			'[title]tt.clip_volume',
			() => {
				let item = this.volumeTool.startInsertion({ clip: true });

				let measurementsRoot = $("#jstree_scene").jstree().get_json("measurements");
				let jsonNode = measurementsRoot.children.find(child => child.data.uuid === item.uuid);
				$.jstree.reference(jsonNode.id).deselect_all();
				$.jstree.reference(jsonNode.id).select_node(jsonNode.id);
			}
		));

		// CLIP POLYGON
		clippingToolBar.append(this.createToolIcon(
			Potree.resourcePath + "/icons/clip-polygon.svg",
			"[title]tt.clip_polygon",
			() => {
				let item = this.viewer.clippingTool.startInsertion({ type: "polygon" });

				let measurementsRoot = $("#jstree_scene").jstree().get_json("measurements");
				let jsonNode = measurementsRoot.children.find(child => child.data.uuid === item.uuid);
				$.jstree.reference(jsonNode.id).deselect_all();
				$.jstree.reference(jsonNode.id).select_node(jsonNode.id);
			}
		));

		{// SCREEN BOX SELECT
			let boxSelectTool = new ScreenBoxSelectTool(this.viewer);

			clippingToolBar.append(this.createToolIcon(
				Potree.resourcePath + "/icons/clip-screen.svg",
				"[title]tt.screen_clip_box",
				() => {
					if (!(this.viewer.scene.getActiveCamera() instanceof THREE.OrthographicCamera)) {
						this.viewer.postMessage(`Switch to Orthographic Camera Mode before using the Screen-Box-Select tool.`,
							{ duration: 2000 });
						return;
					}

					let item = boxSelectTool.startInsertion();

					let measurementsRoot = $("#jstree_scene").jstree().get_json("measurements");
					let jsonNode = measurementsRoot.children.find(child => child.data.uuid === item.uuid);
					$.jstree.reference(jsonNode.id).deselect_all();
					$.jstree.reference(jsonNode.id).select_node(jsonNode.id);
				}
			));
		}

		{ // REMOVE CLIPPING TOOLS
			clippingToolBar.append(this.createToolIcon(
				Potree.resourcePath + "/icons/remove.svg",
				"[title]tt.remove_all_clipping_volumes",
				() => {

					this.viewer.scene.removeAllClipVolumes();
				}
			));
		}

	}

	initFilters() {
		this.initClassificationList();
		this.initReturnFilters();
		this.initGPSTimeFilters();
		this.initPointSourceIDFilters();

	}

	initReturnFilters() {
		let elReturnFilterPanel = $('#return_filter_panel');

		{ // RETURN NUMBER
			let sldReturnNumber = elReturnFilterPanel.find('#sldReturnNumber');
			let lblReturnNumber = elReturnFilterPanel.find('#lblReturnNumber');

			sldReturnNumber.slider({
				range: true,
				min: 0, max: 7, step: 1,
				values: [0, 7],
				slide: (event, ui) => {
					this.viewer.setFilterReturnNumberRange(ui.values[0], ui.values[1])
				}
			});

			let onReturnNumberChanged = (event) => {
				let [from, to] = this.viewer.filterReturnNumberRange;

				lblReturnNumber[0].innerHTML = `${from} to ${to}`;
				sldReturnNumber.slider({ values: [from, to] });
			};

			this.viewer.addEventListener('filter_return_number_range_changed', onReturnNumberChanged);

			onReturnNumberChanged();
		}

		{ // NUMBER OF RETURNS
			let sldNumberOfReturns = elReturnFilterPanel.find('#sldNumberOfReturns');
			let lblNumberOfReturns = elReturnFilterPanel.find('#lblNumberOfReturns');

			sldNumberOfReturns.slider({
				range: true,
				min: 0, max: 7, step: 1,
				values: [0, 7],
				slide: (event, ui) => {
					this.viewer.setFilterNumberOfReturnsRange(ui.values[0], ui.values[1])
				}
			});

			let onNumberOfReturnsChanged = (event) => {
				let [from, to] = this.viewer.filterNumberOfReturnsRange;

				lblNumberOfReturns[0].innerHTML = `${from} to ${to}`;
				sldNumberOfReturns.slider({ values: [from, to] });
			};

			this.viewer.addEventListener('filter_number_of_returns_range_changed', onNumberOfReturnsChanged);

			onNumberOfReturnsChanged();
		}
	}

	initGPSTimeFilters() {

		let elGPSTimeFilterPanel = $('#gpstime_filter_panel');

		{
			let slider = new HierarchicalSlider({
				levels: 4,
				slide: (event) => {
					this.viewer.setFilterGPSTimeRange(...event.values);
				},
			});

			let initialized = false;

			let initialize = () => {

				let elRangeContainer = $("#gpstime_multilevel_range_container");
				elRangeContainer[0].prepend(slider.element);

				let extent = this.viewer.getGpsTimeExtent();

				slider.setRange(extent);
				slider.setValues(extent);


				initialized = true;
			};

			this.viewer.addEventListener("update", (e) => {
				let extent = this.viewer.getGpsTimeExtent();
				let gpsTimeAvailable = extent[0] !== Infinity;

				if (!initialized && gpsTimeAvailable) {
					initialize();
				}

				slider.setRange(extent);
			});
		}


		{

			const txtGpsTime = elGPSTimeFilterPanel.find("#txtGpsTime");
			const btnFindGpsTime = elGPSTimeFilterPanel.find("#btnFindGpsTime");

			let targetTime = null;

			txtGpsTime.on("input", (e) => {
				const str = txtGpsTime.val();

				if (!isNaN(str)) {
					const value = parseFloat(str);
					targetTime = value;

					txtGpsTime.css("background-color", "")
				} else {
					targetTime = null;

					txtGpsTime.css("background-color", "#ff9999")
				}

			});

			btnFindGpsTime.click(() => {

				if (targetTime !== null) {
					viewer.moveToGpsTimeVicinity(targetTime);
				}
			});
		}

	}

	initPointSourceIDFilters() {
		let elPointSourceIDFilterPanel = $('#pointsourceid_filter_panel');

		{
			let slider = new HierarchicalSlider({
				levels: 4,
				range: [0, 65535],
				precision: 1,
				slide: (event) => {
					let values = event.values;
					this.viewer.setFilterPointSourceIDRange(values[0], values[1]);
				}
			});

			let initialized = false;

			let initialize = () => {
				elPointSourceIDFilterPanel[0].prepend(slider.element);

				initialized = true;
			};

			this.viewer.addEventListener("update", (e) => {
				let extent = this.viewer.filterPointSourceIDRange;

				if (!initialized) {
					initialize();

					slider.setValues(extent);
				}

			});
		}

		// let lblPointSourceID = elPointSourceIDFilterPanel.find("#lblPointSourceID");
		// let elPointSourceID = elPointSourceIDFilterPanel.find("#spnPointSourceID");

		// let slider = new ZoomableSlider();
		// elPointSourceID[0].appendChild(slider.element);
		// slider.update();

		// slider.change( () => {
		// 	let range = slider.chosenRange;
		// 	this.viewer.setFilterPointSourceIDRange(range[0], range[1]);
		// });

		// let onPointSourceIDExtentChanged = (event) => {
		// 	let range = this.viewer.filterPointSourceIDExtent;
		// 	slider.setVisibleRange(range);
		// };

		// let onPointSourceIDChanged = (event) => {
		// 	let range = this.viewer.filterPointSourceIDRange;

		// 	let precision = 1;
		// 	let from = `${Utils.addCommas(range[0].toFixed(precision))}`;
		// 	let to = `${Utils.addCommas(range[1].toFixed(precision))}`;
		// 	lblPointSourceID[0].innerHTML = `${from} to ${to}`;

		// 	slider.setRange(range);
		// };

		// this.viewer.addEventListener('filter_point_source_id_range_changed', onPointSourceIDChanged);
		// this.viewer.addEventListener('filter_point_source_id_extent_changed', onPointSourceIDExtentChanged);

	}

	initClassificationList() {
		let elClassificationList = $('#classificationList');

		let addClassificationItem = (code, name) => {
			const classification = this.viewer.classifications[code];
			const inputID = 'chkClassification_' + code;
			const colorPickerID = 'colorPickerClassification_' + code;

			const checked = classification.visible ? "checked" : "";

			let element = $(`
				<li>
					<label style="whitespace: nowrap; display: flex">
						<input id="${inputID}" type="checkbox" ${checked}/>
						<span style="flex-grow: 1">${name}</span>
						<input id="${colorPickerID}" style="zoom: 0.5" />
					</label>
				</li>
			`);

			const elInput = element.find('input');
			const elColorPicker = element.find(`#${colorPickerID}`);

			elInput.click(event => {
				this.viewer.setClassificationVisibility(code, event.target.checked);
			});

			let defaultColor = classification.color.map(c => c * 255).join(", ");
			defaultColor = `rgb(${defaultColor})`;


			elColorPicker.spectrum({
				// flat: true,
				color: defaultColor,
				showInput: true,
				preferredFormat: 'rgb',
				cancelText: '',
				chooseText: 'Apply',
				move: color => {
					let rgb = color.toRgb();
					const c = [rgb.r / 255, rgb.g / 255, rgb.b / 255, 1];
					classification.color = c;
				},
				change: color => {
					let rgb = color.toRgb();
					const c = [rgb.r / 255, rgb.g / 255, rgb.b / 255, 1];
					classification.color = c;
				}
			});

			elClassificationList.append(element);
		};

		const addToggleAllButton = () => { // toggle all button
			const element = $(`
				<li>
					<label style="whitespace: nowrap">
						<input id="toggleClassificationFilters" type="checkbox" checked/>
						<span>show/hide all</span>
					</label>
				</li>
			`);

			let elInput = element.find('input');

			elInput.click(event => {
				this.viewer.toggleAllClassificationsVisibility();
			});

			elClassificationList.append(element);
		}

		const addInvertButton = () => {
			const element = $(`
				<li>
					<input type="button" value="invert" />
				</li>
			`);

			let elInput = element.find('input');

			elInput.click(() => {
				const classifications = this.viewer.classifications;

				for (let key of Object.keys(classifications)) {
					let value = classifications[key];
					this.viewer.setClassificationVisibility(key, !value.visible);
				}
			});

			elClassificationList.append(element);
		};

		const populate = () => {
			addToggleAllButton();
			for (let classID in this.viewer.classifications) {
				addClassificationItem(classID, this.viewer.classifications[classID].name);
			}
			addInvertButton();
		};

		populate();

		this.viewer.addEventListener("classifications_changed", () => {
			elClassificationList.empty();
			populate();
		});

		this.viewer.addEventListener("classification_visibility_changed", () => {

			{ // set checked state of classification buttons
				for (const classID of Object.keys(this.viewer.classifications)) {
					const classValue = this.viewer.classifications[classID];

					let elItem = elClassificationList.find(`#chkClassification_${classID}`);
					elItem.prop("checked", classValue.visible);
				}
			}

			{ // set checked state of toggle button based on state of all other buttons
				let numVisible = 0;
				let numItems = 0;
				for (const key of Object.keys(this.viewer.classifications)) {
					if (this.viewer.classifications[key].visible) {
						numVisible++;
					}
					numItems++;
				}
				const allVisible = numVisible === numItems;

				let elToggle = elClassificationList.find("#toggleClassificationFilters");
				elToggle.prop("checked", allVisible);
			}
		});
	}

	initAccordion() {
		$('.accordion > h3').each(function () {
			let header = $(this);
			let content = $(this).next();

			//header.addClass('accordion-header ui-widget');
			//content.addClass('accordion-content ui-widget');

			content.hide();

			header.click(() => {
				content.slideToggle();
			});
		});

		let languages = [
			["EN", "en"],
			["FR", "fr"],
			["DE", "de"],
			["JP", "jp"],
			["ES", "es"],
			["SE", "se"],
			["ZH", "zh"],
			["IT", "it"],
			["CA", "ca"]
		];

		let elLanguages = $('#potree_languages');
		for (let i = 0; i < languages.length; i++) {
			let [key, value] = languages[i];
			let element = $(`<a>${key}</a>`);
			element.click(() => this.viewer.setLanguage(value));

			if (i === 0) {
				element.css("margin-left", "30px");
			}

			elLanguages.append(element);

			if (i < languages.length - 1) {
				elLanguages.append($(document.createTextNode(' - ')));
			}
		}


		// to close all, call
		// $(".accordion > div").hide()

		// to open the, for example, tool menu, call:
		// $("#menu_tools").next().show()
	}

	initAppearance() {

		const sldPointBudget = this.dom.find('#sldPointBudget');

		sldPointBudget.slider({
			value: this.viewer.getPointBudget(),
			min: 100 * 1000,
			max: 100 * 1000 * 1000,
			step: 1000,
			slide: (event, ui) => { this.viewer.setPointBudget(ui.value); }
		});

		this.dom.find('#sldFOV').slider({
			value: this.viewer.getFOV(),
			min: 20,
			max: 100,
			step: 1,
			slide: (event, ui) => { this.viewer.setFOV(ui.value); }
		});

		$('#sldEDLRadius').slider({
			value: this.viewer.getEDLRadius(),
			min: 1,
			max: 4,
			step: 0.01,
			slide: (event, ui) => { this.viewer.setEDLRadius(ui.value); }
		});

		$('#sldEDLStrength').slider({
			value: this.viewer.getEDLStrength(),
			min: 0,
			max: 5,
			step: 0.01,
			slide: (event, ui) => { this.viewer.setEDLStrength(ui.value); }
		});

		$('#sldEDLOpacity').slider({
			value: this.viewer.getEDLOpacity(),
			min: 0,
			max: 1,
			step: 0.01,
			slide: (event, ui) => { this.viewer.setEDLOpacity(ui.value); }
		});

		this.viewer.addEventListener('point_budget_changed', (event) => {
			$('#lblPointBudget')[0].innerHTML = Utils.addCommas(this.viewer.getPointBudget());
			sldPointBudget.slider({ value: this.viewer.getPointBudget() });
		});

		this.viewer.addEventListener('fov_changed', (event) => {
			$('#lblFOV')[0].innerHTML = parseInt(this.viewer.getFOV());
			$('#sldFOV').slider({ value: this.viewer.getFOV() });
		});

		this.viewer.addEventListener('use_edl_changed', (event) => {
			$('#chkEDLEnabled')[0].checked = this.viewer.getEDLEnabled();
		});

		this.viewer.addEventListener('edl_radius_changed', (event) => {
			$('#lblEDLRadius')[0].innerHTML = this.viewer.getEDLRadius().toFixed(1);
			$('#sldEDLRadius').slider({ value: this.viewer.getEDLRadius() });
		});

		this.viewer.addEventListener('edl_strength_changed', (event) => {
			$('#lblEDLStrength')[0].innerHTML = this.viewer.getEDLStrength().toFixed(1);
			$('#sldEDLStrength').slider({ value: this.viewer.getEDLStrength() });
		});

		this.viewer.addEventListener('background_changed', (event) => {
			$("input[name=background][value='" + this.viewer.getBackground() + "']").prop('checked', true);
		});

		$('#lblPointBudget')[0].innerHTML = Utils.addCommas(this.viewer.getPointBudget());
		$('#lblFOV')[0].innerHTML = parseInt(this.viewer.getFOV());
		$('#lblEDLRadius')[0].innerHTML = this.viewer.getEDLRadius().toFixed(1);
		$('#lblEDLStrength')[0].innerHTML = this.viewer.getEDLStrength().toFixed(1);
		$('#chkEDLEnabled')[0].checked = this.viewer.getEDLEnabled();

		{
			let elBackground = $(`#background_options`);
			elBackground.selectgroup();

			elBackground.find("input").click((e) => {
				this.viewer.setBackground(e.target.value);
			});

			let currentBackground = this.viewer.getBackground();
			$(`input[name=background_options][value=${currentBackground}]`).trigger("click");
		}

		$('#chkEDLEnabled').click(() => {
			this.viewer.setEDLEnabled($('#chkEDLEnabled').prop("checked"));
		});


		// 点云渲染属性选择
		{
			let elAttribute = $("#attribute_options");
			let elGradient = $("#gradient_options");
			let elClassificatioSelect = $("#class_classification");
			elClassificatioSelect.hide();

			// 添加色带参考图功能
			let elShowGradientLegend = $('#show_gradient_legend');
			let gradientLegendContainer = $('#gradient_legend_container');

			elShowGradientLegend.parent().hide();
			elGradient.parent().hide();

			// 设置渲染属性与默认色带的映射
			const attributeToGradient = {
				'rgba': '', // RGB没有对应的色带
				'elevation': 'RAINBOW', // 高程值默认用彩虹
				'intensity': 'GRAYSCALE', // 强度值默认用灰度
				'classification': '', // 分类
				'classification_gradient': 'PLASMA' // 分类(色带)默认用等离子，并且会应用
			};

			// 设置渲染属性的特殊处理映射
			const attributeSpecialHandling = {
				'intensity': 'intensity_gradient', // 强度需要使用带gradient的特殊模式
				'classification': 'classification', // 分类使用普通模式，使用classification材质内置的颜色
				'classification_gradient': 'classification_gradient' // 分类(使用色带)使用新添加的模式
			};

			// 根据选择的属性更新点云渲染
			const updatePointCloudAttribute = (attributeName) => {
				// 更新所有点云的属性
				this.viewer.scene.pointclouds.forEach(pointcloud => {
					// 检查是否需要特殊处理
					if (attributeSpecialHandling[attributeName]) {
						// 对于intensity，我们使用intensity_gradient模式来应用色带
						pointcloud.material.activeAttributeName = attributeSpecialHandling[attributeName];
					} else {
						pointcloud.material.activeAttributeName = attributeName;
					}
				});

				if (attributeName === 'rgba') {
					// 取消选中
					elShowGradientLegend.prop('checked', false);
					elShowGradientLegend.parent().hide();
					gradientLegendContainer.hide();

				} else {
					elShowGradientLegend.parent().show();
				}

				// 如果是分类，显示分类选择器
				if (attributeName === 'classification') {
					elClassificatioSelect.show();
				} else {
					elClassificatioSelect.hide();
				}

				// 如果是RGB则隐藏色带选择
				if (attributeName === 'rgba' || attributeName === 'classification') {
					// 隐藏包含色带选择器的整个li元素
					elGradient.parent().hide();

				} else {
					// 否则显示色带并设置为对应的默认色带
					elGradient.parent().show();

					const defaultGradient = attributeToGradient[attributeName];
					elGradient.val(defaultGradient);

					// 更新所有点云的色带
					this.viewer.scene.pointclouds.forEach(pointcloud => {
						if (Potree.Gradients[defaultGradient]) {
							pointcloud.material.gradient = Potree.Gradients[defaultGradient];
						}
					});
				}
			};

			// 属性选择改变时的处理
			elAttribute.change(function () {
				const attributeName = $(this).val();
				updatePointCloudAttribute(attributeName);
			});

			// 色带选择改变时的处理
			elGradient.change(() => {
				const gradientName = elGradient.val();
				// 更新所有点云的色带
				this.viewer.scene.pointclouds.forEach(pointcloud => {
					if (Potree.Gradients[gradientName]) {
						pointcloud.material.gradient = Potree.Gradients[gradientName];
					}
				});
			});


			// 创建色带渐变条
			const createGradientBar = (gradientName) => {
				const gradient = Potree.Gradients[gradientName];
				if (!gradient) return '';

				let gradientCSS = 'linear-gradient(to right, ';
				gradientCSS += gradient.map(stop => {
					const color = stop[1];
					const position = stop[0] * 100;
					return `rgb(${color.r * 255}, ${color.g * 255}, ${color.b * 255}) ${position}%`;
				}).join(', ');
				gradientCSS += ')';

				return `<div class="gradient-bar" style="background: ${gradientCSS}"></div>
				<div class="gradient-scale">
					<span>最小值</span>
					<span>最大值</span>
				</div>`;

			};

			// 创建分类色带图例
			const createClassificationLegend = () => {
				const classifications = this.viewer.classifications;
				if (!classifications) return '';

				let html = '';

				Object.values(this.viewer.classifications).forEach(classification => {
					const color = classification.color;
					const name = classification.name;
					const rgbColor = `rgb(${color[0] * 255}, ${color[1] * 255}, ${color[2] * 255})`;

					html += `
					<div class="classification-legend-item">
						<div class="classification-color-box" style="background-color: ${rgbColor}"></div>
						<div class="classification-label">${name}</div>
					</div>`;
				});

				return html;
			};

			// 更新色带参考图内容
			const updateGradientLegend = (attributeName) => {
				const legendContent = gradientLegendContainer.find('.gradient-legend-content');
				legendContent.empty();

				let legendHTML = '';
				let legendTitle = '属性色带参考';

				if (attributeName === 'elevation') {
					const gradientName = elGradient.val();
					legendTitle = '高程值色带';
					legendHTML = createGradientBar(gradientName);
				} else if (attributeName === 'intensity') {
					const gradientName = elGradient.val();
					legendTitle = '强度值色带';
					legendHTML = createGradientBar(gradientName);
				} else if (attributeName === 'classification') {
					legendTitle = '分类颜色参考';
					legendHTML = createClassificationLegend();

					// 分类颜色发生改变

				} else if (attributeName === 'classification_gradient') {
					const gradientName = elGradient.val();
					legendTitle = '分类色带参考';
					legendHTML = createGradientBar(gradientName);
				}

				gradientLegendContainer.find('.gradient-legend-title').text(legendTitle);
				legendContent.html(legendHTML);
			};

			// 色带参考图显示/隐藏
			elShowGradientLegend.change(() => {
				if (elShowGradientLegend.prop('checked')) {
					const attributeName = elAttribute.val();
					updateGradientLegend(attributeName);
					gradientLegendContainer.show();
				} else {
					gradientLegendContainer.hide();
				}
			});

			// 当属性改变时，更新参考图
			elAttribute.change(() => {
				if (elShowGradientLegend.prop('checked')) {
					const attributeName = elAttribute.val();
					updateGradientLegend(attributeName);
				}
			});

			// 当色带改变时，更新参考图
			elGradient.change(() => {
				if (elShowGradientLegend.prop('checked')) {
					const attributeName = elAttribute.val();
					updateGradientLegend(attributeName);
				}
			});

			// 当点云加载后，更新选择状态
			this.viewer.scene.addEventListener('pointcloud_added', (e) => {
				let pointcloud = e.pointcloud;
				let currentAttribute = pointcloud.material.activeAttributeName;
				// 如果当前没有设置属性，默认使用rgba
				if (!attributeToGradient.hasOwnProperty(currentAttribute)) {
					currentAttribute = 'elevation';
				}

				// 设置下拉框当前值
				elAttribute.val(currentAttribute);

				// 初始化渲染状态
				updatePointCloudAttribute(currentAttribute);

				// 判断单选框是否选中
				if (elShowGradientLegend.prop('checked')) {
					updateGradientLegend(elAttribute.val());
				}
			});


			// 当分类配置加载后，更新选择状态
			this.viewer.addEventListener('classfication_loaded', (e) => {

				// 判断单选框是否选中
				if (elShowGradientLegend.prop('checked')) {
					updateGradientLegend(elAttribute.val());
				}
			});

			// 导出分类配置
			let elExport = $("#class_export");
			let potreeIcon = `${Potree.resourcePath}/icons/file_geojson.svg`;

			elExport.append(`
				<div style="display: flex; align-items: center">导出分类配置: <a href="#" download="classfication.json5"><img name="class_export_button" src="${potreeIcon}" class="button-icon" style="height: 24px" /></a></div>
			`);

			let elDownloadClass = elExport.find("img[name=class_export_button]").parent();
			elDownloadClass.click((event) => {

				let c = JSON.parse(JSON.stringify(this.viewer.classifications));
				for (let key in c) {
					if (c.hasOwnProperty(key) && c[key].color) {
						c[key].color = c[key].color.map(value => Math.round(value * 255));
					}
				}
				const data = {
					type: "Classification",
					classification: c,
				};
				if (!data.classification) return;
				let dataString = JSON5.stringify(data, null, "\t")
				let url = window.URL.createObjectURL(new Blob([dataString], { type: 'data:application/octet-stream' }));
				elDownloadClass.attr('href', url);
			});

			// 导入分类配置
			let elImport = $("#class_import");
			elImport.append(`
				<div style="display: flex; align-items: center;">
					<span>导入分类配置:</span>
					<label for="classification_file_input" style="cursor: pointer;">
						<img src="${potreeIcon}" class="button-icon" style="height: 24px" />
					</label>
					<input id="classification_file_input" type="file" accept=".json5" style="display: none;" />
				</div>
			`);

			// 添加文件选择和读取功能
			let fileInput = document.getElementById("classification_file_input");
			fileInput.addEventListener('change', (e) => {
				let file = e.target.files[0];
				if (file) {
					let reader = new FileReader();
					reader.onload = (event) => {
						try {
							let data = JSON5.parse(event.target.result);
							Potree.loadClassification(this.viewer, data);
							// 判断单选框是否选中
							if (elShowGradientLegend.prop('checked')) {
								updateGradientLegend(elAttribute.val());
							}

						} catch (error) {
							this.viewer.postError("解析文件内容失败");
							console.error('解析文件内容失败:', error);
						} finally {
							// 重置文件选择
							fileInput.value = '';
						}
					};
					reader.readAsText(file);
				}
			});
		}

		{
			// 加载分类选项select
			let elClassificationOption = $("#classification_options");
			let multiSelectWrapper = null; // 保存对多选框的引用

			// 创建下拉多选框
			const createMultiSelect = () => {
				const wrapper = $('<div class="multi-select-wrapper"></div>');
				const display = $('<div class="multi-select-display">全部</div>');
				const dropdown = $('<div class="multi-select-dropdown"></div>');

				// 更新显示框文本的函数
				const updateDisplayText = () => {
					const checkedOptions = dropdown.find('input:checked:not([value="all"])');
					if (checkedOptions.length === 0) {
						display.text('隐藏');
					} else if (checkedOptions.length === dropdown.find('input:not([value="all"])').length) {
						display.text('显示所有分类');
						allOption.find('input').prop('checked', true);

					} else {
						const texts = checkedOptions.map((_, el) =>
							$(el).closest('label').find('span').text()
						).get();
						allOption.find('input').prop('checked', false);
						display.text(texts.join('、'));
					}
				};


				// 创建"全部"选项
				const allOption = (() => {
					// 检查所有分类是否都可见
					const allVisible = Object.values(this.viewer.classifications)
						.every(classification => classification.visible);

					return $(`
						<div class="multi-select-option">
							<label>
								<input type="checkbox" value="all" ${allVisible ? 'checked' : ''}>
								<span>全部</span>
							</label>
						</div>
					`);
				})();

				allOption.find('input').change((e) => {
					const checked = e.target.checked;
					dropdown.find('input[type="checkbox"]').prop('checked', checked);
					for (let classID in this.viewer.classifications) {
						this.viewer.setClassificationVisibility(classID, checked);
					}
					updateDisplayText();
				});


				dropdown.append(allOption);

				// 添加分类选项
				const addClassificationOptions = () => {
					// 清除旧的分类选项（保留"全部"选项）
					dropdown.find('.multi-select-option:not(:first)').remove();

					for (let classID in this.viewer.classifications) {
						const classification = this.viewer.classifications[classID];
						const option = $(`
							<div class="multi-select-option">
								<label>
									<input type="checkbox" value="${classID}" ${classification.visible ? 'checked' : ''}>
									<span>${classification.name}</span>
								</label>
							</div>
						`);

						option.find('input').change((e) => {
							this.viewer.setClassificationVisibility(classID, e.target.checked);
							const allChecked = dropdown.find('.multi-select-option:not(:first-child) input').toArray()
								.every(input => input.checked);


							allOption.find('input').prop('checked', allChecked);
							updateDisplayText();
						});

						dropdown.append(option);
					}
					updateDisplayText();
				};

				// 点击显示框时切换下拉框显示状态
				display.click(() => {
					dropdown.toggleClass('show');
				});

				// 点击外部时关闭下拉框
				$(document).click((e) => {
					if (!wrapper[0].contains(e.target)) {
						dropdown.removeClass('show');
					}
				});

				wrapper.append(display).append(dropdown);
				addClassificationOptions();

				// 保存更新函数到wrapper对象上，以便后续调用
				wrapper.updateOptions = addClassificationOptions;

				return wrapper;
			};

			// 替换原有select并保存引用
			multiSelectWrapper = createMultiSelect();
			elClassificationOption.replaceWith(multiSelectWrapper);

			// 监听分类变化事件
			this.viewer.addEventListener("classifications_changed", () => {
				// 更新下拉框选项
				multiSelectWrapper.updateOptions();
			});


		}
	}

	initNavigation() {
		let elNavigation = $('#navigation');
		let sldMoveSpeed = $('#sldMoveSpeed');
		let lblMoveSpeed = $('#lblMoveSpeed');

		elNavigation.append(this.createToolIcon(
			Potree.resourcePath + '/icons/earth_controls_1.png',
			'[title]tt.earth_control',
			() => { this.viewer.setControls(this.viewer.earthControls); }
		));

		elNavigation.append(this.createToolIcon(
			Potree.resourcePath + '/icons/fps_controls.svg',
			'[title]tt.flight_control',
			() => {
				this.viewer.setControls(this.viewer.fpControls);
				this.viewer.fpControls.lockElevation = false;
			}
		));

		elNavigation.append(this.createToolIcon(
			Potree.resourcePath + '/icons/helicopter_controls.svg',
			'[title]tt.heli_control',
			() => {
				this.viewer.setControls(this.viewer.fpControls);
				this.viewer.fpControls.lockElevation = true;
			}
		));

		elNavigation.append(this.createToolIcon(
			Potree.resourcePath + '/icons/orbit_controls.svg',
			'[title]tt.orbit_control',
			() => { this.viewer.setControls(this.viewer.orbitControls); }
		));

		elNavigation.append(this.createToolIcon(
			Potree.resourcePath + '/icons/focus.svg',
			'[title]tt.focus_control',
			() => { this.viewer.fitToScreen(); }
		));

		elNavigation.append(this.createToolIcon(
			Potree.resourcePath + "/icons/navigation_cube.svg",
			"[title]tt.navigation_cube_control",
			() => { this.viewer.toggleNavigationCube() }
		));

		elNavigation.append(this.createToolIcon(
			Potree.resourcePath + "/images/compas.svg",
			"[title]tt.compass",
			() => {
				const visible = !this.viewer.compass.isVisible();
				this.viewer.compass.setVisible(visible);
			}
		));

		elNavigation.append(this.createToolIcon(
			Potree.resourcePath + "/icons/camera_animation.svg",
			"[title]tt.camera_animation",
			() => {
				const animation = CameraAnimation.defaultFromView(this.viewer);

				viewer.scene.addCameraAnimation(animation);
			}
		));


		elNavigation.append("<br>");


		elNavigation.append(this.createToolIcon(
			Potree.resourcePath + "/icons/left.svg",
			"[title]tt.left_view_control",
			() => { this.viewer.setLeftView() }
		));

		elNavigation.append(this.createToolIcon(
			Potree.resourcePath + "/icons/right.svg",
			"[title]tt.right_view_control",
			() => { this.viewer.setRightView() }
		));

		elNavigation.append(this.createToolIcon(
			Potree.resourcePath + "/icons/front.svg",
			"[title]tt.front_view_control",
			() => { this.viewer.setFrontView() }
		));

		elNavigation.append(this.createToolIcon(
			Potree.resourcePath + "/icons/back.svg",
			"[title]tt.back_view_control",
			() => { this.viewer.setBackView() }
		));

		elNavigation.append(this.createToolIcon(
			Potree.resourcePath + "/icons/top.svg",
			"[title]tt.top_view_control",
			() => { this.viewer.setTopView() }
		));

		elNavigation.append(this.createToolIcon(
			Potree.resourcePath + "/icons/bottom.svg",
			"[title]tt.bottom_view_control",
			() => { this.viewer.setBottomView() }
		));





		let elCameraProjection = $(`
			<selectgroup id="camera_projection_options">
				<option id="camera_projection_options_perspective" value="PERSPECTIVE">Perspective</option>
				<option id="camera_projection_options_orthigraphic" value="ORTHOGRAPHIC">Orthographic</option>
			</selectgroup>
		`);
		elNavigation.append(elCameraProjection);
		elCameraProjection.selectgroup({ title: "Camera Projection" });
		elCameraProjection.find("input").click((e) => {
			this.viewer.setCameraMode(CameraMode[e.target.value]);
		});
		let cameraMode = Object.keys(CameraMode)
			.filter(key => CameraMode[key] === this.viewer.scene.cameraMode);
		elCameraProjection.find(`input[value=${cameraMode}]`).trigger("click");

		let speedRange = new THREE.Vector2(1, 10 * 1000);

		let toLinearSpeed = (value) => {
			return Math.pow(value, 4) * speedRange.y + speedRange.x;
		};

		let toExpSpeed = (value) => {
			return Math.pow((value - speedRange.x) / speedRange.y, 1 / 4);
		};

		sldMoveSpeed.slider({
			value: toExpSpeed(this.viewer.getMoveSpeed()),
			min: 0,
			max: 1,
			step: 0.01,
			slide: (event, ui) => { this.viewer.setMoveSpeed(toLinearSpeed(ui.value)); }
		});

		this.viewer.addEventListener('move_speed_changed', (event) => {
			lblMoveSpeed.html(this.viewer.getMoveSpeed().toFixed(1));
			sldMoveSpeed.slider({ value: toExpSpeed(this.viewer.getMoveSpeed()) });
		});

		lblMoveSpeed.html(this.viewer.getMoveSpeed().toFixed(1));
	}


	initSettings() {

		{
			$('#sldMinNodeSize').slider({
				value: this.viewer.getMinNodeSize(),
				min: 0,
				max: 1000,
				step: 0.01,
				slide: (event, ui) => { this.viewer.setMinNodeSize(ui.value); }
			});

			this.viewer.addEventListener('minnodesize_changed', (event) => {
				$('#lblMinNodeSize').html(parseInt(this.viewer.getMinNodeSize()));
				$('#sldMinNodeSize').slider({ value: this.viewer.getMinNodeSize() });
			});
			$('#lblMinNodeSize').html(parseInt(this.viewer.getMinNodeSize()));
		}

		{
			let elSplatQuality = $("#splat_quality_options");
			elSplatQuality.selectgroup({ title: "Splat Quality" });

			elSplatQuality.find("input").click((e) => {
				if (e.target.value === "standard") {
					this.viewer.useHQ = false;
				} else if (e.target.value === "hq") {
					this.viewer.useHQ = true;
				}
			});

			let currentQuality = this.viewer.useHQ ? "hq" : "standard";
			elSplatQuality.find(`input[value=${currentQuality}]`).trigger("click");
		}

		$('#show_bounding_box').click(() => {
			this.viewer.setShowBoundingBox($('#show_bounding_box').prop("checked"));
		});

		$('#set_freeze').click(() => {
			this.viewer.setFreeze($('#set_freeze').prop("checked"));
		});
	}


	initFileUpload() {
		$(document).ready(() => {
			const $fileUpload = $('#file-upload');
			const $fileName = $('#file-name');

			const $uploadLabel = $('#upload-label');
			const $uploadStatus = $('#upload-status');
			const $progressContainer = $('#progress-container');

			$fileUpload.on('change', async function (event) {
				const file = event.target.files[0];

				if (!file) return;
				$uploadLabel.hide();
				$progressContainer.css('visibility', 'visible').show();

				// 动态更新文件名显示
				$fileName.text(`${file.name}`);
				// 更新状态为"解析中..."
				$uploadStatus.text("解析中...");

				try {
					await PointCloudApi.uploadPointCloudInChunks(file);

				} catch (error) {
					this.viewer.postError("点云文件上传失败");
					console.error('上传失败:', error);
				}
			});
		});
	}

	// 加载点云列表
	async loadPointCloudList() {
		const elFiles = $("#menu_files").next();

		// 清空文件列表
		elFiles.empty();


		let tree = null;
		let isEmpty = false; // 是否为空状态

		const loadTree = () => {

			tree = $(`<div id="jstree_files" style="margin: 10px 5px; height: 400px; overflow-y: auto;overflow-x: hidden"></div>`);
			elFiles.append(tree);

			tree.jstree({
				'plugins': ["checkbox", "state"],
				'core': {
					"dblclick_toggle": false,
					"state": { "checked": true },
					'check_callback': true,
					"expand_selected_onload": true,
					'restore_focus': false
				},
				"checkbox": {
					"keep_selected_style": true,
					"three_state": false,
					"whole_node": false,
					"tie_selection": false,
				},
			});
			// 监听滚动事件，加载更多数据
			tree.on('scroll', async () => {
				if (tree.scrollTop() + tree.innerHeight() >= tree[0].scrollHeight - 10) {
					loadPage(currentPage);
				}
			});
			// 绑定选中事件
			tree.on("check_node.jstree", (e, data) => {
				const file = data.node;
				if (!file) return;

				let isJump = true;
				if (lastNode && lastNode.id == file.id) {
					isJump = true;
					lastNode = null;
				}
				if (lastNode) isJump = false;
				// 加载点云
				PointCloudApi.loadPointCloud("/api" + file.data.path, file.text, file.data.md5, file.data.handle, isJump);
			});

			// 绑定取消选中事件
			tree.on("uncheck_node.jstree", (e, data) => {
				// 通过名字查找对应的点云
				console.log("uncheck_node.jstree", data);
				let pointcloud = this.viewer.scene.findPointCloudByName(data.node.text);
				// 移除点云
				this.viewer.scene.removePointCloud(pointcloud);
			});


			let lastSelectedNode = null; // 记录上一次选中的节点

			// 绑定单击事件，点击跳转到对应点云
			tree.on('click', '.jstree-anchor', (e) => {

				let instance = $.jstree.reference(e.target);
				let node = instance.get_node(e.target);
				let object = node.data;

				// ignore double click on checkbox
				if (e.target.classList.contains("jstree-checkbox")) {
					return;
				}
				console.log("click_node.jstree", e.shiftKey && lastSelectedNode);
				// 片段选中
				// 如果按下 Shift 键
				if (e.shiftKey && lastSelectedNode) {
					let allNodes = tree.jstree().get_json("#", { flat: true });
					let startIndex = allNodes.findIndex(n => n.id === lastSelectedNode.id);
					let endIndex = allNodes.findIndex(n => n.id === node.id);

					// 确保索引顺序正确
					if (startIndex > endIndex) {
						[startIndex, endIndex] = [endIndex, startIndex];
					}
					// 获取数组范围数组
					let checkNodes = allNodes.slice(startIndex, endIndex + 1).filter(node => !node.state.checked);
					lastNode = checkNodes[checkNodes.length - 1];
					requestAnimationFrame(() => {
						tree.jstree('check_node', checkNodes);
					});

				} else {
					// 更新最后选中的节点
					lastSelectedNode = node;
				}

				let pointcloud = this.viewer.scene.findPointCloudByName(node.text);
				if (!pointcloud) {
					return;
				}
				console.log("click_node.jstree", pointcloud);
				let box = this.viewer.getBoundingBox([pointcloud]);
				let object3D = new THREE.Object3D();
				object3D.boundingBox = box;
				this.viewer.zoomTo(object3D, 1, 500);
			});

			// 绑定双击事件，双击选中渲染点云并跳转到对应点云
			tree.on('dblclick', '.jstree-anchor', (e) => {

				let instance = $.jstree.reference(e.target);
				let node = instance.get_node(e.target);
				let object = node.data;

				// ignore double click on checkbox
				if (e.target.classList.contains("jstree-checkbox")) {
					return;
				}

				// 判断节点是否选中
				if (node.state.checked) {
					tree.jstree('uncheck_node', node);
					return;
				}
				// 选中节点
				tree.jstree('check_node', node);
			});
		};
		loadTree();

		let currentPage = 1;
		const pageSize = 20;
		let isLoading = false;


		const loadPage = async (page) => {
			if (isLoading) return;
			isLoading = true;
			console.log("page", page);

			try {
				const response = await PointCloudApi.getPointCloudList({ pageNum: page, pageSize });
				const pointCloudFiles = response.rows;
				// 如果是首次加载且没有数据，显示空状态
				if (page === 1 && (pointCloudFiles.length === 0)) {
					elFiles.empty();

					console.log("没有点云文件，显示空状态");
					const emptyState = `
						<div id="empty_container" style="text-align: center; padding: 20px; color: #999;">
							<img src="${Potree.resourcePath}/icons/cloud.svg" style="width: 64px; height: 64px; opacity: 0.5">
							<p style="margin-top: 10px;">暂无点云文件</p>
						</div>
					`;
					elFiles.append(emptyState);
					isEmpty = true;

					return;
				}


				let pointcloudsRoot = tree.jstree().get_json("#", { flat: true });



				if (response.total <= pointcloudsRoot.length) {
					return;
				}


				pointCloudFiles.forEach(file => {
					tree.jstree('create_node', "#", {
						"text": file.originalName,
						"icon": file.handle ? `${Potree.resourcePath}/icons/cloud_handle.svg` : `${Potree.resourcePath}/icons/cloud.svg`,
						"data": file,
					}, "last", false, false);
				});
				currentPage++;

			} catch (error) {
				this.viewer.postError("请求点云列表失败");
				console.error('请求点云列表失败', error);
			} finally {
				isLoading = false;
			}
		};

		// 初次加载第一页数据
		loadPage(currentPage);


		// 当前点云是否需要跳转
		let lastNode = null;

		// 监听键盘 ctrl+a 事件，实现全选点云列表
		document.addEventListener('keydown', function (event) {
			// 取消默认事件
			event.preventDefault();
			// 获取所有节点ID
			let getAllNodeIds = () => {
				let allNodes = tree.jstree().get_json("#", { flat: true });
				return allNodes;
			};
			// Ctrl+A (全选)
			if (event.ctrlKey && (event.key === 'a' || event.key === 'A')) {
				console.log('全选操作');
				let nodes = getAllNodeIds().filter(node => !node.state.checked);
				// 获取最后一个节点
				lastNode = nodes[nodes.length - 1];
				// 批量操作，减少DOM重绘
				requestAnimationFrame(() => {
					tree.jstree('check_node', nodes);
				});
			}
			// 取消
			if (event.ctrlKey && (event.key === 'z' || event.key === 'Z')) {
				console.log('取消全选操作');
				let nodes = getAllNodeIds().filter(node => node.state.checked);
				requestAnimationFrame(() => {
					tree.jstree('uncheck_node', nodes);
				});
			}
			// 反选
			if (event.ctrlKey && (event.key === 'q' || event.key === 'Q')) {
				console.log('反选操作');
				let checkNodes = getAllNodeIds().filter(node => !node.state.checked);
				let uncheckNodes = getAllNodeIds().filter(node => node.state.checked);
				lastNode = checkNodes[checkNodes.length - 1];
				requestAnimationFrame(() => {
					tree.jstree('uncheck_node', uncheckNodes);
					tree.jstree('check_node', checkNodes);
				});
			}
		});


		let onPointCloudUploaded = (e) => {

			if (isEmpty) {
				elFiles.empty();
				loadTree();
				isEmpty = false;
			}

			let fileInfo = e.data;
			// 秒传，查找节点是否已存在
			if (fileInfo.status == "1") {
				// 查找所有子节点
				let pointcloudsRoot = tree.jstree().get_json("#", { flat: true });
				// 通过文件名和md5查找节点
				let jsonNode = pointcloudsRoot.find(child => {
					return child.text === fileInfo.fileName && child.data.md5 === fileInfo.fileMd5;
				});

				// 选中节点
				if (jsonNode) {
					tree.jstree('check_node', jsonNode);
					return;
				}
			}
			// 在首部创建节点
			const nodeID = tree.jstree('create_node', "#", {
				"text": fileInfo.fileName,
				"icon": `${Potree.resourcePath}/icons/cloud.svg`,
				"data": {
					path: fileInfo.fileUrl,
					size: fileInfo.fileSize,
					md5: fileInfo.fileMd5,
					originalName: fileInfo.fileName,
					handle: null
				},
			}, "first", false, false);
			// 选中节点
			tree.jstree('check_node', nodeID);
		};

		this.viewer.scene.addEventListener("pointcloud_uploaded", onPointCloudUploaded);


		// 监听点云分割处理完毕事件
		this.viewer.scene.addEventListener("pointcloud_handled", (e) => {

			let fileInfo = e.data;
			// 查找所有子节点
			let pointcloudsRoot = tree.jstree().get_json("#", { flat: true });
			// 通过文件名和md5查找节点
			let jsonNode = pointcloudsRoot.find(child => {
				return child.text === fileInfo.fileName && child.data.md5 === fileInfo.fileMd5;
			});
			console.log("pointcloud_handled", jsonNode);

			// 获取对应的 DOM 元素
			jsonNode.data.path = fileInfo.fileUrl;

			let domNode = $.jstree.reference(jsonNode.id).get_node(jsonNode.id, true);
			$(domNode).find('.jstree-themeicon').css("background-image", `url(${Potree.resourcePath}/icons/cloud_handle.svg)`);
		})


	}

	initPointCloudHandle() {
		const btnHandle = $("#handle_btn")
		btnHandle.click(async () => {
			let pointclouds = this.viewer.scene.pointclouds;
			if (!pointclouds || pointclouds.length === 0) {
				viewer.postError("点云列表未选中任何点云", { duration: 2000 });
				return;
			}

			try {
				for (let pointcloud of pointclouds) {
					if (pointcloud.handle) {
						viewer.postError(`${pointcloud.name}点云已处理完毕,请勿重复处理`, { duration: 2000 });

						continue;
					}
					let index = this.fileMd5s.findIndex(item => item === pointcloud.md5)
					if (index !== -1) {
						viewer.postError(`${pointcloud.name}点云正在处理,请勿重复提交`, { duration: 2000 });
						// 已经存在就跳过处理
						continue;

					}
					this.fileMd5s.push(pointcloud.md5);
					const response = await PointCloudApi.pointCloudHandle(pointcloud.name, pointcloud.md5);

					if (response.code === 200) {
						viewer.postMessage(`${pointcloud.name}点云处理中...`, { id: pointcloud.md5 });
						// 
						// 上传切片开始之后就要建立 SSE 连接
						const eventSource = new EventSource(`${POINT_CLOUD_API.SSE_ANALYZE}${pointcloud.md5 + "_handle"}`);

						eventSource.onmessage = (event) => {
							let info = JSON.parse(event.data);
							console.log("SSE Message:", info);
							if (info.status == "0") {
								this.viewer.postError(info.message);
							}
							if (info.status == "1") {

								viewer.postMessage(`${info.fileName}点云处理成功！`, { duration: 3000 });

								// 移除点云
								let pointcloud = this.viewer.scene.findPointCloudByName(info.fileName);
								this.viewer.scene.removePointCloud(pointcloud);

								// 重新加载
								if (info.fileUrl) {
									PointCloudApi.loadPointCloud("/api" + info.fileUrl, info.fileName, info.fileMd5, "1");
									this.viewer.scene.handlePointCloud(info);
								}
							}

							// 处理完毕
							viewer.hideMessageById(info.fileMd5);
							let index = this.fileMd5s.findIndex(item => item === info.fileMd5);
							if (index !== -1) {
								this.fileMd5s.splice(index, 1);
							}
						};
						eventSource.onerror = (error) => {
							console.error("SSE Error:", error);
							eventSource.close();
						};
					}
				}
			} catch (error) {
				this.viewer.postError("请求点云处理接口失败");
				console.error('请求点云列表失败', error);
			}

		});




	}


	initPointCloudVector() {
		const btnHandle = $("#handle_vector");

		btnHandle.click(async () => {
			let pointclouds = this.viewer.scene.pointclouds;
			if (!pointclouds || pointclouds.length === 0) {
				viewer.postError("点云列表未选中任何点云", { duration: 2000 });
				return;
			}

			try {
				for (let pointcloud of pointclouds) {
					if (!pointcloud.handle) {
						viewer.postError(`${pointcloud.name}点云未分割处理，无法导出矢量文件`, { duration: 2000 });
						continue
					}

					let index = this.exportVectorMd5s.findIndex(item => item === pointcloud.md5);
					if (index !== -1) {
						viewer.postError(`${pointcloud.name}点云正在导出,请勿重复导出`, { duration: 2000 });
						continue

					}
					this.exportVectorMd5s.push(pointcloud.md5);

					const response = await PointCloudApi.exportVector(pointcloud.name, pointcloud.md5);

					if (response.code === 200) {
						viewer.postMessage(`${pointcloud.name}点云矢量文件导出中...`, { id: pointcloud.md5 });



						// 创建新的 SSE 连接
						const eventSource = new EventSource(`${POINT_CLOUD_API.SSE_ANALYZE}${pointcloud.md5 + "_vector"}`);

						eventSource.onmessage = (event) => {
							let info = JSON.parse(event.data);
							console.log("SSE Message:", info);
							if (info.status == "0") {
								this.viewer.postError(info.message);
							}
							if (info.status == "1") {

								// 下载zip
								window.location.href = "/api" + info.fileUrl;
								viewer.postMessage(`${info.fileName}点云矢量文件导出成功！`, { duration: 3000 });
							}


							// 处理完毕
							viewer.hideMessageById(info.fileMd5);
							let index = this.exportVectorMd5s.findIndex(item => item === info.fileMd5);
							if (index !== -1) {
								this.exportVectorMd5s.splice(index, 1);
							}

							eventSource.close();

						};

						eventSource.onerror = (error) => {
							console.error("SSE Error:", error);
							eventSource.close();

						};
					}
				}
			} catch (error) {
				this.viewer.postError("请求点云处理接口失败");
				console.error('请求点云列表失败', error);
			}
		});
	}
}

